/**
 * giftTags — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const giftTagsPack: ToilePack = {
    slug: 'gift-tags',
    category: 'gifttags',
    name: 'Gift tags',
    tagline: tagline('tag sheets', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'holiday', label: 'Holiday', subject: 'fir sprigs, holly berries, snowflakes and red baubles'},
        {key: 'birthday', label: 'Birthday', subject: 'balloons, confetti, candles and striped gift boxes'},
        {key: 'kraft', label: 'Kraft floral', subject: 'pressed wildflowers and leaf wreaths on kraft card'},
    ],
    styles: [
        {key: 'illustrated', label: 'Illustrated', style: 'full-color painted motifs, soft shading', palette: 'a bright cheerful palette', framing: 'six tags, 2×3 grid, cut lines, punched holes'},
        {key: 'calligraphic', label: 'Calligraphic', style: 'flourished pen strokes and thin swashes', palette: 'one dark ink, hairline borders', framing: 'six tags, 2×3 grid, cut lines, punched holes'},
        {key: 'stamped', label: 'Rubber-stamped', style: 'uneven ink impressions, broken edges', palette: 'one ink on bare card', framing: 'six tags, 2×3 grid, cut lines, punched holes'},
    ],
    directions: ['for wedding favours', 'in forest green and gold', 'with a blank name line'],
}
